import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([ A11y, Autoplay, EffectFade, Navigation, Pagination ]);
        
        let config = {
            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Navigation (arrow)
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },

            // Pagination (bullet)
            pagination: {
                el: '.c-pagination__bullets',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if(nbSlides > 1) {
            let swiperHome = new Swiper('.home-slideshow .swiper-container', config);

            if(dataSlideAuto === '1') {
                let boutonPlayPause = document.getElementById('js-boutonAutoplay')

                boutonPlayPause.addEventListener('click', function () {

                    if(swiperHome.autoplay.running === true) {
                        swiperHome.autoplay.stop();

                        boutonPlayPause.classList.remove('nav-swiper-autoplay--play')
                        boutonPlayPause.classList.add('nav-swiper-autoplay--pause');

                        // console.log('autoplay running : ' + swiperHome.autoplay.running);
                    }

                    else {
                        swiperHome.autoplay.start();

                        boutonPlayPause.classList.remove('nav-swiper-autoplay--pause')
                        boutonPlayPause.classList.add('nav-swiper-autoplay--play');

                        // console.log('autoplay running : ' + swiperHome.autoplay.running);
                    }
                });
            }
        }
    }

    // Slider News

    const newsSlideshow = document.querySelector('.news .swiper-container') !== null;

    if (newsSlideshow) {
        let newsSlides = document.querySelectorAll('.news .swiper-container .swiper-slide').length;

        Swiper.use([ Pagination, A11y ]);

        let newsConfig = {
            grabCursor : 'true',
            speed: 700,
            // loop : true,
            slidesPerView: 'auto',
            spaceBetween: 20,

            breakpoints: {
                641: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                961: {
                    slidesPerView: 2.37,
                    spaceBetween: 20,
                },

                1201: {
                    slidesPerView: 2.37,
                    spaceBetween: 30,
                },
            },

            // Pagination (bullet)
            pagination: {
                el: '.news-pagination__bullets',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(window.innerWidth > 960) {
            if(newsSlides > 2) {
                let swiperNews = new Swiper('.news .swiper-container', newsConfig);
            }
        } else {
            if(newsSlides > 1) {
                let swiperNews = new Swiper('.news .swiper-container', newsConfig);
            }    
        }
    }

    // slider Agenda
    const eventsSlideshow = document.querySelector('.home-events .swiper-container') !== null;
                
    if (eventsSlideshow) {
        let eventsSlides = document.querySelectorAll('.home-events .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Pagination ]);

        let eventsConfig = {
            effect : 'slide',
            grabCursor : 'false',
            speed: 700,
            loop: false,
            slidesPerView: 'auto',

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            // Pagination (bullet)
            pagination: {
                el: '.events-pagination__bullets',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                1201: {
                    spaceBetween: 30,  
                    slidesPerView: 3,

                },
        
                961: {
                    spaceBetween: 20, 
                    slidesPerView: 3,
                },
                
                641: {
                    spaceBetween: 20,
                    slidesPerView: 2,

                },
        
                0: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                }
            }
        }

        let swiperevents = new Swiper('.home-events .swiper-container', eventsConfig);

        function updateMargins() {
            let slides = document.querySelectorAll('.home-events .swiper-container .swiper-slide');

            slides.forEach(function (slide) {
                slide.style.marginTop = '0px';
            });

            let activeIndex = swiperevents.activeIndex;

            if (activeIndex >= 0 && activeIndex < slides.length) {
                slides[activeIndex].style.marginTop = '0px';

                for (let i = 1; i <= slides.length - 1; i++) {
                    let nextIndex = (activeIndex + i) % slides.length;
                    slides[nextIndex].style.marginTop = (i % 2 === 1) ? '0px' : '35px';
                }
            }
        }

        if(window.innerWidth > 960) {
            swiperevents.on('slideChange', updateMargins);

            updateMargins();
        }
    }


    /*** Kiosque ***/
    const kiosqueSlideshow = document.querySelector('.kiosque .swiper-container') !== null;
            
    if (kiosqueSlideshow) {
        let kiosqueSlides = document.querySelectorAll('.kiosque .swiper-container .swiper-slide').length;

        Swiper.use([ Pagination, A11y ]);

        let kiosqueConfig = {
            effect: 'fade',
            grabCursor : 'true',
            spaceBetween: 30,
            loop: false,

            // Pagination (bullet)
            pagination: {
                el: '.kiosque-pagination__bullets',
                type: 'bullets', // default
                clickable: true,
            },

        }

        let kiosqueConfigMobile = { // can't change swiper effect using breakpoints 
            effect: 'slide',
            grabCursor : 'false',
            speed: 700,
            spaceBetween: 20,
            slidesPerView: 1,
            loop: false,

            // Pagination (bullet)
            pagination: {
                el: '.kiosque-pagination__bullets',
                type: 'bullets', // default
                clickable: true,
            },

        }

        if(kiosqueSlides >= 2) {
            if(window.innerWidth > 640) {
                let swiperKiosque = new Swiper('.kiosque .swiper-container', kiosqueConfig);
            } else {
                let swiperKiosque = new Swiper('.kiosque .swiper-container', kiosqueConfigMobile);
            }

        }
    }





}
